import { apiClient } from '@/api/core/apiClient';
import { API_CONFIG } from '@/api/core/apiConfig';
import type { ApiResponse } from '@/api/shared/types';
import type { LC_GetShiftGroupsOut, ShiftGroup } from './shiftGroups.types';
import { mapShiftGroupOutToModel } from './shiftGroups.mapper';


export class ShiftGroupsCatalogService {
  /** GET /v1/catalog/shiftgroups */
  async getShiftGroups(signal?: AbortSignal): Promise<ApiResponse<ShiftGroup[]>> {
    const response = await apiClient.get<LC_GetShiftGroupsOut>(
      API_CONFIG.ENDPOINTS.CATALOG.SHIFT_GROUPS,
      { signal },
    );

    if (response.success && response.data) {
      return {
        ...response,
        data: response.data.map(mapShiftGroupOutToModel),
      };
    }

    return { ...response, data: null };
  }
}

export const shiftGroupsCatalogService = new ShiftGroupsCatalogService();
